export enum OnboardingStep {
	SceneClickAndDrag = 'SceneClickAndDrag',
	LobeAdd = 'LobeAdd',
	LobeClickAndDrag = 'LobeClickAndDrag',
	LobeMultiSelect = 'LobeMultiSelect',
	LobeSnap = 'LobeSnap'

	/**
	 * UX prototype steps for device orientation may be deprecated due to CR-419 scheduled in IS-1960
	 */
	// DeviceOrientation = 'DeviceOrientation',
	// DeviceOrientationSelection = 'DeviceOrientationSelection'
}
